// extracted by mini-css-extract-plugin
export default {"row":"ResultsWrapper_row__3RL2+","rowMarginTop":"ResultsWrapper_rowMarginTop__FeEMl","rowMarginBottom":"ResultsWrapper_rowMarginBottom__9-jgA"};